// couponApi.js
import api from "./apiBase";

function applyCoupon(code, designIds) {
  return api.post(`/coupons/${encodeURIComponent(code)}/preview`, {
    designIds,
  });
}

export { applyCoupon };
